import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'

import { fetchOpenings } from '../actions/openings'
import { fetchMachines } from '../actions/machines'

import { renderInputField, renderSelectField } from '../utils/forms'

class OpeningsFilterForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false }

    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { fetchMachines } = this.props

    fetchMachines()

    this.load(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  load(props) {
    const { machines } = props

    if (!this.state.loaded && machines) {
      this.setState({ loaded: true })
    }
  }

  submit(props) {
    return this.props.fetchOpenings(props.Machine, props.Status, props.StartDate, props.EndDate)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  render() {
    const { loaded } = this.state
    const { error, submitting, handleSubmit, machines } = this.props

    if (!loaded) {
      return (
        <LoadingProgress />
      )
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <div className="row">
          <div className="col">
            <Field name="Machine"
                   component={renderSelectField}
                   label="Máquina">
              <option value="">Todas</option>
              {machines.map(machine => {
                return (
                  <option value={machine.Serial} key={machine._id}>
                    {machine.Serial}
                  </option>
                )
              })}
            </Field>
          </div>
          <div className="col">
            <Field name="Status"
                   component={renderSelectField}
                   label="Estado">
              <option value="">Todos</option>
              <option value="PENDING">PENDIENTES</option>
              <option value="ONPROCESS">EN PROCESO</option>
              <option value="COMPLETE">COMPLETADOS</option>
              <option value="ERROR">ERROR</option>
              <option value="CANCELED">CANCELADOS</option>
            </Field>
          </div>
          <div className="col">
            <Field name="StartDate"
                   component={renderInputField}
                   type="date"
                   label="Fecha inicio"/>
          </div>
          <div className="col">
            <Field name="EndDate"
                   component={renderInputField}
                   type="date"
                   label="Fecha fin"/>
          </div>
          <div className="col openings-filter-btn-col">
            <div className="form-group">
              <button className="btn bg-vw-dark text-white openings-filter-submit-btn"
                      type="submit"
                      disabled={submitting}>
                <i className="fas fa-sync mr-1"></i>Actualizar
              </button>
            </div>
          </div>
        </div>
        { error && <div className="alert alert-danger mt-2">{error}</div> }
      </form>
    )
  }
}

OpeningsFilterForm = reduxForm({
  form: 'OpeningsFilterForm',
})(OpeningsFilterForm)

const mapStateToProps = state => ({
  machines: state.machines.machines,
  initialValues: {
    Machine: '',
    Status: '',
    StartDate: new Date().toISOString().substring(0, 10),
    EndDate: new Date().toISOString().substring(0, 10)
  }
})

const mapDispatchToProps = dispatch => ({
  fetchOpenings: bindActionCreators(fetchOpenings, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(OpeningsFilterForm)

